import React, { useState, useEffect } from 'react'
import axios from 'axios'
import styles from "./Testimonials.module.css";
import Testimonials from './Testimonials';

function TestimonialsSec({ data }) {

  const [testimonials, setTestimonials] = useState(data.testimonials);
  const [index, setIndex] = useState(data.index);
  const [duration, setDuration] = useState(data.duration);


  return (
    <>
    {testimonials?.length > 0 && <Testimonials testimonials={testimonials} tindex={index} duration={duration} playIcon={false} title={false} />}
    </>
  );
}

export default TestimonialsSec;
